const define = {
    "buttonText.discoverDefineClassic": "ทำความรู้จัก Define® Classic​",
    "buttonText.discoverDefineFresh": "ทำความรู้จัก Define® Fresh",
    "buttonText.findStores": "ค้นหาร้านค้า",
    "buttonText.learnMore": "เรียนรู้เพิ่มเติม",
    "buttonText.shopNow": "ช้อปเลย",
    "buttonText.tryTheVirtualMirror": "Filter ลองเลนส์",
    "buttonText.shopNow": "ช้อปเลย",
    "buttonText.tryTheVirtualMirror": "Filter ลองเลนส์",
    "features.paragraph1.title": "ดีไซน์เพื่อความงาม",
    "features.paragraph1.description": "ด้วยการผสานวิทยาศาสตร์ และเทคนิคการวาดลายเส้นซ้อนเลเยอร์สี 3 ชั้น ให้ดวงตาของคุณสวย เป็นประกาย และมีเสน่ห์",
    "features.paragraph1.description": "ด้วยการผสานวิทยาศาสตร์ และเทคนิคการวาดลายเส้นซ้อนเลเยอร์สี 3 ชั้น ให้ดวงตาของคุณสวย เป็นประกาย และมีเสน่ห์",
    "features.paragraph2.title": "ชุ่มชื้น สบายตา",
    "features.paragraph2.description": "ผลิตจากวัสดุไฮโดรเจล ให้ออกซิเจนผ่านเข้าสู่ดวงตา มอบความชุ่มชื้นกับดวงตาได้ยาวนาน",
    "features.paragraph2.description": "ผลิตจากวัสดุไฮโดรเจล ให้ออกซิเจนผ่านเข้าสู่ดวงตา มอบความชุ่มชื้นกับดวงตาได้ยาวนาน",
    "features.paragraph3.title": "ป้องกันรังสียูวี Class 2 <span>##</span>",
    "features.paragraph3.freshdescription": "ป้องกันดวงตาจากรังสี UVA 81% และ UVB 97% ให้คุณเอนจอยทุกกิจกรรมกลางแจ้งได้ทุกวัน",
    "features.paragraph3.classicdescription": "ป้องกันดวงตาจากรังสี UVA 81% และ UVB 97% ให้คุณเอนจอยทุกกิจกรรมกลางแจ้งได้ทุกวัน",
    "headline.classic.description": "การออกแบบจากแรงบันดาลใจของโทนสีธรรมชาติ <br /> แต่งแต้มความมีมิติ และเสน่ห์ให้ดวงตาคุณ",
    "headline.classic.title": "Define® Classic",
    "headline.fresh.description": "สีสันที่ได้รับแรงบันดาลใจจากโทนสีธรรมชาติเสริมให้ดวงตาคุณสดใสเป็นประกาย",
    "headline.fresh.description": "สีสันที่ได้รับแรงบันดาลใจจากโทนสีธรรมชาติเสริมให้ดวงตาคุณสดใสเป็นประกาย",
    "headline.fresh.title": "Define® Fresh",
    "lensWear.howToPut": "วิธีใส่-ถอดคอนแทคเลนส์อย่างสะอาดและถูกต้อง",
    "lensWear.insert1.description": "ล้างมือด้วยสบู่ที่ไม่มีส่วนผสมของน้ำหอม และเช็ดมือให้แห้งด้วยผ้าที่ไม่มีขุย ",
    "lensWear.insert1.title": "ล้างมือให้สะอาด",
    "lensWear.insert2.description": "วางเลนส์ลงบนปลายนิ้วมือ ตรวจสอบขอบเลนส์ให้เป็นรูปถ้วย หากขอบเลนส์แบะออกเป็นรูปจานแสดงว่าเลนส์กลับด้านอยู่ ",
    "lensWear.insert2.title": "วางเลนส์ให้ถูกด้าน ",
    "lensWear.insert3.description": "ใช้สองนิ้วเก็บขนตาบนและล่าง ดึงเปลือกตาให้เปิด พร้อมใส่เลนส์",
    "lensWear.insert3.title": "ดึงเปลือกตาพร้อมใส่เลนส์",
    "lensWear.insert4.description": "มองบน ค่อยๆ วางเลนส์เข้าไปในดวงตา แล้วหลับตาลงสักครู่เพื่อให้คอนแทคเลนส์เข้าที่",
    "lensWear.insert4.title": "หลับตาให้เลนส์เข้าที่",
    "lensWear.insertion": "วิธีใส่",
    "lensWear.removal": "วิธีถอด",
    "lensWear.remove1.description": "ล้างมือให้สะอาดและเช็ดมือให้แห้ง จากนั้นมองขึ้น และค่อยๆดึงเปลือกตาล่างลงด้วยนิ้วกลาง",
    "lensWear.remove1.title": "ดึงเปลือกตาล่างลง",
    "lensWear.remove2.description": "ใช้นิ้วกลางแตะด้านล่างของเลนส์ และเลื่อนเลนส์ไปทางฝั่งตาขาวของคุณ ",
    "lensWear.remove2.title": "เลื่อนเลนส์ไปด้านข้าง ",
    "lensWear.remove3.description": "ค่อย ๆ ใช้นิ้วชี้และนิ้วโป้งหยิบเลนส์ออกระวังอย่าให้โดนเล็บ",
    "lensWear.remove3.title": "หยิบเลนส์ออก",
    "lensWear.remove4.description": "1-day ACUVUE® Define ® เป็นคอนแทคเลนส์รายวัน ดังนั้นเมื่อถอดออกแล้วสามารถทิ้งได้ทันที ",
    "lensWear.remove4.title": "ทิ้งเลนส์ ",
    "lensWear.title": "การใส่-ถอดคอนแทคเลนส์",
    "related.discover": "ทำความรู้จักเลนส์อื่นๆ​",
    "showNow.title": "ช้อปเลย",
    "showNow.description": "สั่งซื้อ ACUVUE® ส่งตรงถึงบ้านคุณได้แล้ววันนี้",
    "showNow.physical.details": "ค้นหาร้านค้าใกล้คุณ",
    "specs.additionalInfo": "รายละเอียดสินค้า",
    "specs.baseCurve": "ความโค้ง (มม.)",
    "specs.baseCurve.detail": "8.5mm",
    "specs.centre": "เส้นผ่านศูนย์กลาง (มม.)",
    "specs.centre.fresh.detail": "14.2mm",
    "specs.centre.classic.detail": "14.2mm",
    "specs.internal": "สารให้ความชุ่มชื้น",
    "specs.internal.detail": "Polyvinylpyrrolidone (PVP) จากเทคโนโลยี LACREON® ให้ความชุ่มชื้นยาวนาน 20 ชั่วโมง",
    "specs.material": "วัสดุ",
    "specs.material.detail": "ไฮโดรเจล (เอตาฟิลคอล เอ)",
    "specs.oxygen": "การผ่านของออกซิเจน",
    "specs.oxygen.detail": "(Dk/t) (boundary & edge corrected) 25.5 x 10-9 (for -3.00D)",
    "specs.packageSize": "ขนาดบรรจุ",
    "specs.packageSize.fresh.detail": "30 ชิ้น / กล่อง",
    "specs.packageSize.classic.detail": "30 ชิ้น / กล่อง",
    "specs.freshpowerRange": "ค่าสายตา",
    "specs.classicpowerRange": "ค่าสายตา",
    "specs.freshpowerRange.detail": "Plano<br/> -0.50D to -6.00D (0.25D steps);<br /> -6.50D to -9.00D (0.50D steps)",
    "specs.classicpowerRange.detail": "Plano<br/> -0.50D to -6.00D (0.25D steps);<br /> -6.50D to -9.00D (0.50D steps)",
    "specs.specifications": " ",
    "specs.water": "ค่าอมน้ำ",
    "specs.water.detail": "58%"
}

const download_now = {
  "download_now.title": "Enjoy RM50 of Exclusive Welcome Rewards",
  "download_now.p": "Join as a MyACUVUE member to receive up to RM50 of worth of exclusive rewards with your first purchase of ACUVUE® contact lenses.",
  "download_now.button": "Learn More",
}

function define_references_fn (otherString) {
  return `
    <h1>หมายเหตุ คอนแทคเลนส์มีส่วนผสมของสารป้องกัน UVA และ UVB ในระดับหนึ่ง แต่ไม่สามารถทดแทนการใส่แว่นตากันแดดได้</h1>
    <p>ไม่ควรใส่คอนแทคเลนส์เกิน 12 ชม.ต่อวัน ไม่ควรใส่ทำกิจกรรมทางน้ำ อ่านคำเตือนในฉลากและเอกสารกำกับเครื่องมือแพทย์ก่อนใช้ คำแนะนำ การใช้เลนส์สัมผัสควรได้รับการสั่งใช้และตรวจติดตามทุกปีโดยจักษุแพทย์ หรือผู้ประกอบโรคศิลปะโดยอาศัยทัศนมาตรศาสตร์เท่านั้น คำเตือน การใช้เลนส์สัมผัสโดยเฉพาะอย่างยิ่งการใช้ที่ผิดวิธีมีความเสี่ยงต่อการอักเสบหรือการติดเชื้อของดวงตา อาจรุนแรงถึงขั้น สูญเสียตาอย่างถาวรได้
    </p>

    <p>ข้อห้ามใช้
      <br /> 1.ห้ามใส่เลนส์สัมผัสนานเกินระยะเวลาใช้งานที่กำหนด
      <br /> 2.ห้ามใส่เลนส์สัมผัสร่วมกับบุคคลอื่น
      <br /> 3.ห้ามใส่เลนส์สัมผัสทุกชนิดเวลานอน ถึงแม้จะเป็นชนิดใส่นอนได้ก็ตาม ควรถอดล้างทำความสะอาดทุกวัน
    </p>

    <h1>ข้อควรระวัง</h1>
    <p>
      1.ผู้ที่มีสภาวะของดวงตาผิดปกติ เช่น ต้อเนื้อ ต้อลม ตาแดง กระจกตาไวต่อความรู้สึกลดลง ตาแห้ง กะพริบตาไม่เต็มที่ ไม่ควรใส่เลนส์สัมผัส
      <br /> 2.ควรใช้น้ำยาล้างเลนส์สัมผัสที่ใหม่ และเปลี่ยนน้ำยาฆ่าเชื้อโรคสำหรับเลนส์สัมผัสทุกครั้งที่แช่เลนส์สัมผัสและแม้ไม่ใส่เลนส์สัมผัสควรเปลี่ยนน้ำยาใหม่ในตลับทุกวัน
      <br /> 3.ควรเปลี่ยนตลับ ใส่เลนส์สัมผัสทุกสามเดือน
      <br /> 4.ไม่ควรใส่เลนส์สัมผัส ขณะว่ายน้ำ เพราะอาจทำให้เกิดการติดเชื้อที่ตาได้
      <br /> 5.ล้างมือ ฟอกสบู่ ให้สะอาดทุกครั้งก่อนสัมผัสเลนส์
      <br /> 6.หากเกิดอาการผิดปกติ เช่น เจ็บหรือปวดตาเป็นอย่างมากร่วมกับอาการแพ้แสง ตามัว น้ำตาไหลมาก หรือ ตาแดง ให้หยุดใช้เลนส์สัมผัสทันที และรีบพบจักษุแพทย์โดยเร็ว
      <br /> 7.ห้ามใช้เลนส์สัมผัสถ้าภาชนะบรรจุอยู่ในสภาพชำรุดหรือถูกเปิดก่อนใช้งาน
      <br /> ผู้นำเข้า บริษัท จอห์นสัน แอนด์ จอห์นสัน เมดเทค (ประเทศไทย) จำกัด เลขที่ 134/1 ซอยฉลองกรงุ 31 แขวงลำปลาทิว เขตลาดกระบัง กรุงเทพมหานคร 10520 โทร. 001 800 156 207 8225 1-DAY ACUVUE DEFINE Brand Contact Lenses with LACREON 66-2-2-2-0001175${otherString ? otherString : ''}
    </p>
  `
}

const define_references = {
  "references.content": define_references_fn(),
  "references.contentclassic": define_references_fn(' <br /> ฆพ. 2509/2567 TH2024-0322 <br /> ฆพ. 2510/2567 TH2024-0323'),
  "references.contentfresh": define_references_fn(' <br /> ฆพ. 2432/2567 TH2024-0293 <br /> ฆพ. 2434/2567 TH2024-0294 <br /> ฆพ. 2431/2567 TH2024-0295'),
  "references.content_primary": define_references_fn(' <br /> ฆพ. 3044/2567 ฆพ.3024/2567 ฆพ. 2435/2567 ฆพ. 2509/2567 ฆพ. 2510/2567 ฆพ.3023/2567 ฆพ.3022/2567 ฆพ.2918/2567 ฆพ.2919/2567 ฆพ.2920/2567 ฆพ. 2432/2567 ฆพ. 2431/2567 ฆพ. 2434/2567  TH2025-026 TH2026-018')
}


export default {
  ...define,
  ...define_references,
  ...define_references,
  ...download_now
};
